import { useLocale } from "next-intl";
import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";
import { useCallback } from "react";
import { defaultLocale, locales } from "./config";

const routing = defineRouting({
    locales,
    defaultLocale,
    // tr (default) stays unprefixed; az is served under /az/*.
    localePrefix: "as-needed",
    localeCookie: false,
});

// Locale-aware replacements for next/link and next/navigation. Every internal
// navigation must go through these so a click inside /az stays on /az; an
// ESLint rule (eslint.config.mjs) blocks the raw imports outside src/i18n.
//
// Locale resolution: the client reads NextIntlClientProvider, the server reads
// getRequestConfig (src/i18n/request.ts), both fed by proxy.ts. No [locale]
// route segment is needed.

const navigation = createNavigation(routing);

export const { Link, useRouter, usePathname } = navigation;
const { getPathname } = navigation;

// Explicit annotation so TS treats this as never-returning at call sites
// (control-flow narrowing needs a declared type, which destructuring lacks).
export const redirect: typeof navigation.redirect = navigation.redirect;

// For the few places that must navigate outside the router (window.location
// on full-page checkout hops). Stable per locale, safe in dependency arrays.
export function useLocalizeHref() {
    const locale = useLocale();
    return useCallback(
        (href: string) => getPathname({ href, locale }),
        [locale],
    );
}
